import React from 'react';
import ReactDOM from 'react-dom/client';
import { MaxUI } from '@maxhub/max-ui';
import '@maxhub/max-ui/dist/styles.css';
import { App } from './App.tsx';
import './index.css';

const platform = ((): 'ios' | 'android' => {
  const p = window.WebApp?.platform;
  return p === 'ios' ? 'ios' : 'android';
})();

const colorScheme: 'light' | 'dark' = window.matchMedia('(prefers-color-scheme: dark)').matches
  ? 'dark'
  : 'light';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MaxUI platform={platform} colorScheme={colorScheme}>
      <App />
    </MaxUI>
  </React.StrictMode>
);
